import { useRef } from 'react'
import PrivateOfferResaleAuthorizationTabs from '../PrivateOfferResaleAuthorizationTabs/PrivateOfferResaleAuthorizationTabs'
import PartnerProductsWrapper from '../PartnerProductsWrapper'
import PrivateOffersWrapper from '../PrivateOffersWrapper'
import { useLocation, useParams } from 'react-router-dom'
import { PrivateOffersWrapperUIV2 } from '../../components/PrivateOffersWrapperUIV2'
import { ResaleAuthorizationsWrapperUIV2 } from '../../components/ResaleAuthorizationWrapperUIV2'
import ResaleAuthorizationsWrapper from '../ResaleAuthorizationsWrapper'

const PrivateOffersWrapperWithTabs = () => {
  const { search } = useLocation()
  const { secureKey, partnerId, privateOfferId, productId, cloud, accountId } =
    useParams<{
      secureKey: string
      partnerId: string
      privateOfferId?: string
      productId?: string
      cloud?: string
      accountId?: string
    }>()
  const tableEl = useRef<HTMLDivElement>(null)
  const privateOfferWithTabProps = {
    secureKeyProp: secureKey,
    productIdProp: productId,
    partnerIdProp: partnerId,
    privateOfferIdProp: privateOfferId,
  }

  const privateOffersComponent = (
    <PrivateOffersWrapper {...privateOfferWithTabProps}>
      {({ externalBaseURL, search, crmOpportunityId }) => (
        <PrivateOffersWrapperUIV2
          crmOpportunityId={crmOpportunityId}
          externalBaseURL={externalBaseURL}
          search={search}
          tableEl={tableEl}
        />
      )}
    </PrivateOffersWrapper>
  )
  const resaleOffersComponent = (
    <ResaleAuthorizationsWrapper {...privateOfferWithTabProps}>
      {({ externalBaseURL, search, crmOpportunityId }) => (
        <ResaleAuthorizationsWrapperUIV2
          crmOpportunityId={crmOpportunityId}
          externalBaseURL={externalBaseURL}
          search={search}
          tableEl={tableEl}
        />
      )}
    </ResaleAuthorizationsWrapper>
  )
  return (
    <PartnerProductsWrapper>
      <PrivateOfferResaleAuthorizationTabs
        privateOfferComp={privateOffersComponent}
        resaleOfferComp={resaleOffersComponent}
        search={search}
        subUrl={
          cloud && accountId
            ? `/external-apps/hubspot/v1/${secureKey}/partners/${partnerId}/cloud/${cloud}/accounts/${accountId}/product-listing/offers-authorizations`
            : `/external-apps/hubspot/v1/${secureKey}/partners/${partnerId}/product-listing/offers-authorizations`
        }
        isExternal={true}
        tableEl={tableEl}
      />
    </PartnerProductsWrapper>
  )
}
export default PrivateOffersWrapperWithTabs
